import axios from "axios";
import { BaseUrl } from "../Config/config";

axios.defaults.headers.post["Content-Type"] = "application/json";
export async function InvokeApi({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  postData = {},
}) {
  const reqObj = {
    method,
    url: BaseUrl + path,
    headers,
  };

  reqObj.params = queryParams;

  if (method === "POST") {
    reqObj.data = postData;
  }
  if (method === "PUT") {
    reqObj.data = postData;
  }
  if (method === "DELETE") {
    reqObj.data = postData;
  }
  if (method === "PATCH") {
    reqObj.data = postData;
  }

  let results;

  try {
    results = await axios(reqObj);

    return results.data;
  } catch (error) {

    if (error?.response?.status === 401) {
    }
    return {
      code: error?.response?.status,
      message: error?.response?.data?.message ? error?.response?.data?.message : "",
    };
  }
}
